import { useEffect, useState } from "react";
import { IS_PLAYWRIGHT } from "@util/constant";
import { cn, getTimeSince } from "@util/helpers";
import dayjs from "dayjs";

export type UpdatedTimeProps = {
  className?: string;
  updated?: string;
  edited?: string;
};

/**
 * UpdateTime
 * Description: The edited time of the article
 * @param {UpdateTimeProps} props
 * @returns {ReactElement}
 */
const EditedTime = ({
  className = "",
  updated = "",
  edited = "",
}: UpdatedTimeProps): React.ReactElement => {
  const [timeSinceUpdate, setTimeSinceUpdate] = useState("");
  const [displayUpdateTime, setDisplayUpdateTime] = useState(false);
  const hasArticleBeenUpdated = updated < edited;

  useEffect(() => {
    const isLessThanOneDay = dayjs().diff(edited, "hours") <= 23;
    setDisplayUpdateTime(hasArticleBeenUpdated && isLessThanOneDay);
    setTimeSinceUpdate(getTimeSince(edited));
  }, [edited, updated, hasArticleBeenUpdated]);

  // @TODO: Update this condition to handle Playwright tests
  // This is a temporary fix to avoid rendering the component in Playwright tests
  // as it may cause issues with the test environment.
  // Ideally, we should mock the time-related functions in tests instead of skipping rendering.
  // This condition can be removed once the tests are updated to handle time-related functions properly.
  if (IS_PLAYWRIGHT) return <></>;

  return (
    <>
      {displayUpdateTime ? (
        <div
          data-testid="update-time-component"
          className={cn("truncate font-poppins text-7xs uppercase", className)}
        >
          UPDATED {timeSinceUpdate}
        </div>
      ) : null}
    </>
  );
};

export default EditedTime;
